module.exports = __webpack_public_path__ + "img/yj_head.dd05bb60.png";